import { render, staticRenderFns } from "./mantenimiento-periodico-instalaciones.vue?vue&type=template&id=8bf8544a&scoped=true&"
import script from "./mantenimiento-periodico-instalaciones.vue?vue&type=script&lang=js&"
export * from "./mantenimiento-periodico-instalaciones.vue?vue&type=script&lang=js&"
import style0 from "./mantenimiento-periodico-instalaciones.vue?vue&type=style&index=0&id=8bf8544a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf8544a",
  null
  
)

export default component.exports